module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAIFJREFUOE9jZKASYASZI7Vrsh/D/78zwWYyMqc/c8vdhCzOxMQkgc2+f//+vYCphxi0c8JzmOJ/DAwvnrnmSaKL43I4TD11DZLd0e3/l5l9BshW5r8/Mx57lG4EsWHiTAwM2L3GwPACph7sImoA6ho0GmsYcQJKQ6OxhsiDIzivAQB7t7QTuFSwfwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/commonG.png
// module id = 477
// module chunks = 0